module.exports = __webpack_public_path__ + "photoArabesques.fe90f8e6235ddf00b5de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme/photoArabesques.png
// module id = 639
// module chunks = 1